import React from 'react';

import {
  Chip,
  ChipProps,
  Typography,
  capitalize,
  TypographyProps,
} from '@mui/material';
import classNames from 'classnames';

import { useIntl } from '@kamernet/core/Intl';

import { ListingChipLabelTranslations } from '@kamernet/modules/Listing/translations';
import { ListingChipLabels } from '@kamernet/modules/Listing/types';

import styles from './ListingChip.module.css';

export interface ListingChipProps {
  label: ListingChipLabels;
  size?: ChipProps['size'];
  variant?: TypographyProps['variant'];
  className?: string;
}

export const ListingChip = ({
  label,
  variant = 'subtitle3',
  size = undefined,
  className = undefined,
}: ListingChipProps): JSX.Element => {
  const { T } = useIntl();
  return (
    <Typography
      component={Chip}
      variant={variant}
      label={capitalize(T(ListingChipLabelTranslations[label]))}
      className={classNames(className, styles.root)}
      size={size}
    />
  );
};
